import { getOrderCacheDetailPanel ,getOrderCacheDetailById,deleteOrderCacheDetail } from "../../services/OrderCacheDetailServices";
import { PedidosDetalleContext } from "./PedidosDetalleContext"

export const PedidosDetalleState = ({ children }) => {

    const getPedidosDetallePanelData = async (searchOca, searchArt, page, perPage) => {
        let res = await getOrderCacheDetailPanel(searchOca, searchArt, page, perPage)
        return res;
    };

    const deletePedidosDetalleData = async (body) => {
        const res = await deleteOrderCacheDetail(body)
        if (res) getPedidosDetallePanelData()
        return res
    }

    const getPedidosDetalleByIdData = async (id) => {
        let res = await getOrderCacheDetailById(id)
        return res
    }

    return <PedidosDetalleContext.Provider value={{
        getPedidosDetallePanelData,
        deletePedidosDetalleData,
        getPedidosDetalleByIdData
    }} >
        {children}
    </PedidosDetalleContext.Provider>
}